import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { AnalyticsModule } from 'src/app/shared/analytics/analytics.module'
import { CollectionCtaComponent } from './collection-cta.component'
import { OldSvgModule } from 'src/app/libs/_deprecated/svg/old-svg.module'
@NgModule({
  imports: [CommonModule, RouterModule, AnalyticsModule, OldSvgModule],
  declarations: [CollectionCtaComponent],
  exports: [CollectionCtaComponent]
})
export class CollectionCtaComponentModule {}
